import { useState, useEffect } from 'react';

/**
 * 检测是否为移动设备
 * 不依赖屏幕尺寸，而是检查 UserAgent 和触摸能力
 */
export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            if (typeof window === 'undefined') return;
            
            const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
            
            // 常见的移动设备标识
            const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
            
            // 检查 UserAgent
            const isMobileUA = mobileRegex.test(userAgent);
            
            // 检查触摸点 (iPad Pro 等可能不带 Mobile 标识但支持触摸)
            // 注意：某些触屏笔记本也会有 maxTouchPoints > 0，所以不能仅凭此判断
            // 这里我们主要依赖 UA，辅以 maxTouchPoints 针对 iOS 13+ iPad
            const isIPad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
            
            setIsMobile(isMobileUA || isIPad);
        };

        checkMobile();
    }, []);

    return isMobile;
}
